import React from 'react';

function SuspenseFallback(props) {
    return (
        <div></div>
    );
}

export default SuspenseFallback;